import { useState, MouseEvent } from "react";
import { useHistory } from "react-router";
import { useAppSelector } from "../../../../context-store";
import adminClasses from "../../../landing-pages/admin/admin.module.css";
import PrimarySkillModel from "../../../../models/admin/skill/response/PrimarySkillModel";
import PrimarySkillRequestModel from "../../../../models/admin/skill/request/PrimarySkillRequestModel";
import { PageModeEnum } from "../../../../models/enums/PageModeEnum";
import Table from "@mui/material/Table";
import TableBody from "@mui/material/TableBody";
import TableCell from "@mui/material/TableCell";
import TableRow from "@mui/material/TableRow";
import TablePagination from "@mui/material/TablePagination";
import TableContainer from "@mui/material/TableContainer";
import TableSortLabel from "@mui/material/TableSortLabel";
import TableHead from "@mui/material/TableHead";

interface PrimarySkillGridProps {
    primarySkillList: PrimarySkillModel[];
    totalSize: number;
    currentPage: number;
    pagesize: number;
    sortColumn: string;
    sortDirection: "asc" | "desc";
    pageSizesList: number[];
    primarySkillFilterValue: string;
    onPrimarySkillAction: (row: PrimarySkillRequestModel, actionType: string) => void;
    onPageChangeAction: (newPage: number) => void;
    onPageSizeChangeAction: (newPageSize: number) => void;
    onSortAction: (newSortColumn: string, sortDir: string) => void;
    onFilterAction: (filterColumn: string, filterValue: string) => void;
};

const PrimarySkillGridComponent = (props: PrimarySkillGridProps) => {
    const [primarySkillFilter, setPrimarySkillFilter] = useState<string>(props.primarySkillFilterValue);
    let loggedInUser = useAppSelector((state) => state.authState.loggedInUser);

    const editPrimarySkill = (row: PrimarySkillModel) => {
        if (loggedInUser !== null) {
            let primarySkillRequestModel: PrimarySkillRequestModel = {
                primarySkillId: row.primarySkillId,
                primarySkillName: row.primarySkillName,
                description: row.description,
                userId: loggedInUser?.userId
            }
            props.onPrimarySkillAction(primarySkillRequestModel, PageModeEnum.Edit);
        }
    };

    const columnsPrimarySkill = [
        { key: "PrimarySkillName", text: "Primary Skill", sort: true, searchable: true },
        { key: "Description", text: "Description", sort: true, searchable: false },
        { key: "Actions", text: "Actions", sort: false, searchable: false }
    ];

    const createSortHandler = (property: string) => (event: React.MouseEvent) => {
        props.onSortAction(property, props.sortDirection === "asc" ? "desc" : "asc")
    };

    const handleChangePage = (event: any, newPage: number) => {
        props.onPageChangeAction(newPage);
    };

    const handleChangeRowsPerPage = (event: any) => {
        props.onPageSizeChangeAction(parseInt(event.target.value, 10));
    };

    const filterOnChange = (key: string, value: string) => {
        setPrimarySkillFilter(value);
        if ((value && value.length > 2) || value === "") {
            props.onFilterAction(key, value);
        }
    };

    return (
        <div className="row">
            <div className="col-md-12">
                <TableContainer>
                    <Table>
                        <TableHead>
                            <TableRow>
                                {columnsPrimarySkill.map((column: any) => (
                                    <TableCell key={column.key} className="table-header-cell">
                                        {column.sort &&
                                            <TableSortLabel
                                                active={props.sortColumn === column.key}
                                                direction={props.sortColumn === column.key ? props.sortDirection : "asc"}
                                                onClick={createSortHandler(column.key)}>
                                                {column.text}
                                            </TableSortLabel>
                                        }
                                        {column.searchable &&
                                            <input type="text" placeholder="search" className="mat-header-filter-input" value={primarySkillFilter}
                                                onClick={(e) => e.stopPropagation()} onChange={(e) => filterOnChange(column.key, e.target.value)}></input>
                                        }
                                        {!column.sort &&
                                            <span>{column.text}</span>
                                        }
                                    </TableCell>
                                ))}
                            </TableRow>
                        </TableHead>
                        <TableBody>
                            {props.primarySkillList.map((skill: PrimarySkillModel, index) => (
                                <TableRow>
                                    <TableCell>{skill.primarySkillName}</TableCell>
                                    <TableCell>{skill.description}</TableCell>
                                    <TableCell>
                                        <a onClick={() => { editPrimarySkill(skill); }} title="Edit">
                                            <i className="far fa-edit grid-icon blue"></i>
                                        </a>
                                    </TableCell>
                                </TableRow>
                            ))}
                        </TableBody>
                    </Table>
                </TableContainer>
                <TablePagination
                    rowsPerPageOptions={props.pageSizesList}
                    component="div"
                    count={props.totalSize}
                    rowsPerPage={props.pagesize}
                    page={props.currentPage - 1}
                    onPageChange={handleChangePage}
                    onRowsPerPageChange={handleChangeRowsPerPage}
                />
            </div>
        </div>
    );
};
export default PrimarySkillGridComponent;